import { S } from "../styles";

export function AccessDenied({ feature }: { feature: string }) {
  return (
    <div
      style={{
        ...S.card,
        background: "#fff5f5",
        border: "1px solid #ffc9c9",
        textAlign: "center",
        padding: "40px 24px",
      }}
    >
      <div style={{ fontSize: 32, marginBottom: 12 }}>🔒</div>
      <h2 style={{ ...S.h2, color: "#c0392b" }}>Access Denied</h2>
      <p style={{ color: "#666" }}>
        Your role does not have permission to access <strong>{feature}</strong>.
        Contact your administrator if you believe this is an error.
      </p>
    </div>
  );
}
